module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1037-0164ba2ce2ad84e7f025143e22077b2c.png";